export enum ECompanyCondition {
  A = "a",
  B = "b",
  C = "c",
  D = "d",
  E = "e",
  ALL = "all",
}
